"use client";
import React, { createContext, useState } from "react";

interface AppContextProps {
  locale: string;
  setLocale: (locale: string) => void;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  features: Feature[];
  newFeatureAr: string;
  newFeatureEn: string;
  addFeature: () => void;
  removeFeature: (index: number) => void;
  setNewFeatureAr: (value: string) => void;
  setNewFeatureEn: (value: string) => void;
}

interface Feature {
  feature_ar: string;
  feature_en: string;
}

export const AppContext = createContext<AppContextProps>({
  locale: "en",
  setLocale: () => {},
  isShow: false,
  setIsShow: () => {},
  features: [],
  newFeatureAr: "",
  newFeatureEn: "",
  addFeature: () => {},
  removeFeature: () => {},
  setNewFeatureAr: () => {},
  setNewFeatureEn: () => {},
});

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [locale, setLocale] = useState("en");
  const [isShow, setIsShow] = useState(false);

  const [features, setFeatures] = useState<Feature[]>([]);
  const [newFeatureAr, setNewFeatureAr] = useState("");
  const [newFeatureEn, setNewFeatureEn] = useState("");

  const addFeature = () => {
    if (newFeatureAr && newFeatureEn) {
      setFeatures([
        ...features,
        { feature_ar: newFeatureAr, feature_en: newFeatureEn },
      ]);
      setNewFeatureAr("");
      setNewFeatureEn("");
    }
  };

  const removeFeature = (index: number) => {
    setFeatures(features.filter((_, i) => i !== index));
  };

  return (
    <AppContext.Provider
      value={{
        locale,
        setLocale,
        isShow,
        setIsShow,
        features,
        newFeatureAr,
        newFeatureEn,
        addFeature,
        removeFeature,
        setNewFeatureAr,
        setNewFeatureEn,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
